import React from "react";
import Login from "../components/AuthPages/Login";

function LoginPage() {
  return (
    <>
      <Login />
    </>
  );
}

export default LoginPage;
